import { Tooltip, Zoom, IconButton } from '@material-ui/core';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';


interface IProps {
    link: string
    stopPropagation?: boolean
}

let ViewIconButton = ({ link, stopPropagation }: IProps) => {
    return (
        <Tooltip title="View" TransitionComponent={Zoom}>
            <IconButton
                size="small"
                color="primary"
                component={Link}
                to={link}
                onClick={(ev: any) => {
                    if (stopPropagation === true)
                        ev.stopPropagation();
                }}
            >
                <SearchIcon />
            </IconButton>
        </Tooltip>
    )
}

export default ViewIconButton;